/**
 * Bold360-only flow without Genesys related features: authenticationMode: "BOLD360", isGenesysEnabled: false
 * Genesys-only flow without Bold360 authentication: authenticationMode: "GENESYS", isGenesysHybridModeDisabled: true
 * Hybrid flow: authenticationMode: "GENESYS", isGenesysHybridModeDisabled: false, needs paired organization
 */

import { Overrides } from './environment.overrides';
import { Config } from './models/config.model';
import { Features } from './models/features.model';
import { isBold } from './environment.helper';

(<any>window).config = (<any>window).config || {};
(<any>window).languages = (<any>window).languages || {
  key: 'en-US',
  name: 'English',
  priority: 1
};
(<any>window).supportedLanguages = (<any>window).dxSupportedLanguages || ['en-US'];

export const defaultFeatures: Features = {
  operatorStatusDropdown: true,
  multiLane: true,
  geoAffinity: true,
  fileShare: true,
  assistedBrowsing: true,
  smsMessages: true,
  asyncMessage: true,
  nanorep: true,
  contextualKnowledgeBaseSearch: true,
  botChatActions: true,
  discussions: true,
  showChatInRC: true,
  messagingMonitorView: true,
  emailPreview: true,
  agentAutoLogout: true,
  agentStats: true,
  liveWorkloadMonitorView: true,
  skeletonLoading: false,
  showLiveWorkloadTabs: true,
  omniQueue: true,
  genesysDxChat: false,
  genesysDxEmail: false
};

export const defaultConfig: Config = {
  ...(<any>window).config,
  languages: (<any>window).languages,
  environment: 'local',
  fileUploadSizeLimit: 25600, // kbyte
  genesysFileUploadSizeLimit: 10240, //kbyte
  chatFileUploadSizeLimit: 256000, // kbyte
  timerDisplaySecondsRemainingThreshold: 119,
  supportedCannedIntegrations: ['zendesk', 'salesforce'],
  lastMessagesTextLength: 100,
  features: defaultFeatures,
  segmentIOApiKey: 'l0eyhs6w7g', // logmein/boldchat-dev
  // Genesys related configs
  cookieDomain: 'bold360.io',
  isBoldDomain: isBold(),
  authenticationMode: 'BOLD360',
  isGenesysHybridModeDisabled: false,
  genesysClientId: '3e263187-8df7-4bf4-9e66-0c1b88262cd6',
  assetPrefix: Overrides.assetPrefix,
  supportedLanguages: (<any>window).supportedLanguages,
  genesysRichTextEnabledProviders: [
    { type: 'facebook', isUrlImageEnabled: false, escapingEnabled: false },
    { type: 'webmessaging', isUrlImageEnabled: true, escapingEnabled: true },
    { type: 'whatsapp', isUrlImageEnabled: false, escapingEnabled: false }
  ]
};
